import axios from 'axios';

import { formatShapes } from './index';

export default () =>
  axios({
    url: 'https://oss.canalplustelecom.com/interop-rest/listShapes',
    method: 'GET'
  })
    .then(response => response.data)
    .then(formatShapes);
